// extracted by mini-css-extract-plugin
export default {"root":"Screen__root--3map0","logo":"Screen__logo--2OF-h","logo_vk":"Screen__logo_vk--aBRNp","content":"Screen__content--3qrMN","closeIcon":"Screen__closeIcon--2g3Ec"};